async function fetchWithAuth(
  url: RequestInfo | URL,
  options: RequestInit | undefined
) {
  const res = await fetch(url, options);
  if (res.status === 401) {
    window.location.href = "/#/signin";
    return;
  }
  return res;
}
export default fetchWithAuth;
